import './shared.scss';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import {Close, Search} from "@mui/icons-material";
import Categories from './categories';
import ICategory from '../interfaces/ICategory';

// helpers
const capitalize = (text: string) =>
    text.charAt(0).toUpperCase() + text.substr(1);

const clamp = (value: number) => Math.max(0, value);

const isBetween = (value: number, floor: number, ceil: number) =>
    value >= floor && value <= ceil;

// hooks
const useScrollspy = (ids: string[], offset: number = 0) => {
    const [activeId, setActiveId] = useState("");

    useLayoutEffect(() => {
        const listener = () => {
            const scroll = window.pageYOffset;

            const position = ids
                .map((id) => {
                    const element = document.getElementById(id);

                    if (!element) return { id, top: -1, bottom: -1 };

                    const rect = element.getBoundingClientRect();
                    const top = clamp(rect.top + scroll - offset);
                    const bottom = clamp(rect.bottom + scroll - offset);

                    return { id, top, bottom };
                })
                .find(({ top, bottom }) => isBetween(scroll, top, bottom));

            setActiveId(position?.id || "");
        };

        listener();

        window.addEventListener("resize", listener);
        window.addEventListener("scroll", listener);

        return () => {
            window.removeEventListener("resize", listener);
            window.removeEventListener("scroll", listener);
        };
    }, [ids, offset]);

    return activeId;
};



export default function CategoryBar(props: { setIsFiltering: any; onSearch: (arg0: string) => void; categories: ICategory[]; }) {
    const setIsFiltering = props.setIsFiltering;
    const categories = props.categories;

    const [showSearchBar, setShowSearchBar] = useState(false);
    const activeId = useScrollspy(categories.map(({ id }) => 'category_' + id), 100);

    const escFunction = useCallback((event: any) => {
        if (event.key === "Escape") {
            stopFiltering();
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const stopFiltering = () => {
        setShowSearchBar(false);
        setIsFiltering(false);
    };

    return (
        <div className="category-selector-outer">
            <div className={`${showSearchBar ? 'transition-all border-secondary-500 hover:bg-gray-50' : 'border-primary-300'} category-selector `}>
                {showSearchBar ?
                    <div className="flex justify-between p-3.5">
                        <Search className="mr-2" />
                        <input
                            onChange={e => {props.onSearch(e.target.value)}}
                            autoFocus className="search-bar"
                            placeholder="Typ hier om een gerecht te zoeken..."
                            id="search-bar"
                            type="text"/>
                        <button onClick={() => stopFiltering()}><Close color="secondary" /></button>
                    </div>
                    :
                    <Categories activeId={activeId} categories={categories} setShowSearchBar={setShowSearchBar} />
                }
            </div>
        </div>
    )
}
